import { AirplaneOffIcon } from './AirplaneOffIcon';

/**
 * author: Colton Wiscombe
 * id D2D1D38E-ABE7-47B6-9405-DC6BDBA1C335
 * name airplane-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/airplane-off.svg
 * tags
 * - Transportation + Flying 
 */
export const PlaneOffIcon = AirplaneOffIcon;
export default PlaneOffIcon